<template>
  <div class="menu">
    <div class="menu-mobile">
      <div class="menu-mobile__close"></div>

      <div class="default-container">
        <ul class="menu-mobile__list">
          <li>
            <router-link
              :to="{ name: `${lang}-impianto`, params: { lang } }"
              :class="{ 'isActive': fromRoute.meta.pageName === 'impianto'}">
                {{ $t('vociMenu.impianto') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-come-funziona`, params: { lang } }"
              :class="{ 'isActive': ['processings', 'processings/list'].includes(fromRoute.meta.pageName) }">
                {{ $t('vociMenu.comeFunziona') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-vantaggi`, params: { lang } }"
              :class="{ 'isActive': fromRoute.meta.pageName === 'vantaggi'}">
                {{ $t('vociMenu.vantaggi') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-azienda`, params: { lang } }"
              :class="{ 'isActive': fromRoute.meta.pageName === 'company'}">
                {{ $t('vociMenu.azienda') }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: `${lang}-contatti`, params: { lang } }"
              :class="{ 'isActive': fromRoute.meta.pageName === 'contacts'}">
                {{ $t('vociMenu.contatti') }}
            </router-link>
          </li>
        </ul>

        <ul class="menu-mobile__langs">
          <li>
            <a
            :href="$_convertRoute(fromRoute.name, lang, 'it')"
            :class="{ 'isActive': lang === 'it'}">
              IT
            </a>
          </li>
          <li>
            <a
            :href="$_convertRoute(fromRoute.name, lang, 'en')"
            :class="{ 'isActive': lang === 'en'}">
              EN
            </a>
          </li>
        </ul>

      </div>
    </div>

    <div class="menu-desktop"></div>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import _ from 'lodash'

export default {
  mixins: [ lang ],
  data: () => ({
    fromRoute: undefined
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from
    })
  },
  methods: {
    $_convertRoute (routeName, currentLang, lang) {
      return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${lang}-`) }).href
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
.menu {
  position: fixed;
  top: 0;
  z-index: 75;
  height: 100vh;
  width: 100%;
}

.menu-mobile {
  background-color: #30AE8D;
  padding-top: 8rem;
  height: 100vh;
  width: 100%;

  .default-container{
    height: 100%;

    .menu-mobile__list{
      top: 0;
    }
  }

  li{
    display: block;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  li a{
    font-size: 1rem;
    line-height: 1.6;
    padding-top: 1rem;
    padding-bottom: 1rem;
    text-decoration: none;
    font-family: 'IBM Plex Mono', sans-serif;
    font-weight: 400;
    letter-spacing: 1px;
    color: #FFF;
    text-transform: uppercase;
  }
  li a.isActive{
    color: #FFF;
  }

  li a::before{
    position: absolute;
    left: -1px;
    bottom: .5rem;
    width: 0;
    content: "";
    height: 2px;
    background-color: #FFF;
    transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  li a.isActive::before{
    width: calc(100% + 2px);
  }
}

.menu-transition-enter {
  opacity: 0;
}

.menu-transition-enter-to {
  opacity: 1;
}

.menu-transition-enter-active {
  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
  top: 0;
}

.menu-transition-leave {
  opacity: 1;
}

.menu-transition-leave-to {
  opacity: 0;
}

.menu-transition-leave-active {
  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menu-mobile__langs{
  position: fixed;
  bottom: 4rem;
  width: 100%;

  li{
    display: inline-block;
    margin-right: 1.5rem;
    a{
      font-size: .8rem;
      color: #9B9B9B;
      text-transform: uppercase;
      font-weight: 300;
      color: #FFF;
    }
    a.router-link-active{
      color: #FFF;
    }
    a::before{
      position: absolute;
      left: -1px;
      bottom: .2rem;
      width: 0;
      content: "";
      height: 2px;
      background-color: #FFF;
      transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    a.router-link-active::before{
      width: calc(100% + 2px);
    }
  }
}

</style>
